import { Injectable } from '@angular/core';
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from "./parse.service";
import { Damage, DamageAnalysis } from '../model/damage.model';
import { environment } from '../../environments/environment';
import { listOptions } from '../model/settings.model';

@Injectable()
export class TraceService {

  constructor() { }

  public getByDamages(damages: DamageAnalysis[]): Promise<any> {
    return new Promise((resolve, reject) => {
      let query = new parse.Query(parse.Object.extend('Trace'));

      var listDamage = []
      damages.forEach(damage => {
        listDamage.push({
          __type: 'Pointer',
          className: 'Damage',
          objectId: damage.id
        })
      });

      query.containedIn('damagePtr', listDamage)
        .limit(10000)


      query.find().then((retrievedTraces: any) => {
        //console.log("retrievedTraces",retrievedTraces)
        resolve(retrievedTraces);
      }, (error) => {
        //console.error('Could not retrieve ROIs : ', error.code, error.message);
        reject(error);
      });
    });
  }

  public saveTrace(tchekId: string, action: string, damageId?: string, data?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      var Trace = parse.Object.extend("Trace");
      var trace = new Trace();
      trace.set("user", parse.User.current());
      if (environment.isLocal) {
        trace.set('toSync', true)
      }
      trace.set("action", action);
      if (tchekId) {
        var tchekPointer = {
          __type: "Pointer",
          className: "Tchek",
          objectId: tchekId
        };
        trace.set("tchek", tchekPointer);
      }
      if (data)
        trace.set("data", data);

      if (damageId) {
        var damagePointer = {
          __type: "Pointer",
          className: "Damage",
          objectId: damageId
        };
        trace.set("damagePtr", damagePointer);
      }

      trace.save(null, {
        success: function (t) {
          resolve(t)
        },
        error: function (t, err) {
          reject(err)
        }
      });
    });
  }

  public saveTraceList(tchekId: string, list: { action: string, damageId: string, data: any }[]): Promise<any> {
    return new Promise((resolve, reject) => {
      let TraceList = []
      list.forEach(e => {
        let trace = new (parse.Object.extend("Trace"));
        trace.set("user", parse.User.current());
        if (environment.isLocal) {
          trace.set('toSync', true)
        }
        trace.set("action", e.action);
        if (e.data)
          trace.set("data", e.data);
        if (tchekId) {
          var tchekPointer = {
            __type: "Pointer",
            className: "Tchek",
            objectId: tchekId
          };
          trace.set("tchek", tchekPointer);
        }
        if (e.damageId) {
          var damagePointer = {
            __type: "Pointer",
            className: "Damage",
            objectId: e.damageId
          };
          trace.set("damagePtr", damagePointer);
        }
        TraceList.push(trace)
      });

      parse.Object.saveAll(TraceList).then(r => { resolve(r) }).catch(err => { reject(err) })
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/trace.service.ts